import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { officeAddressSchema } from '../../model/schemas';

export function validateHeadOfficeAddress(
  value: unknown,
  shouldSkipEmpty = true
): ValidationError[] {
  if (!value && shouldSkipEmpty) return [];
  const result = officeAddressSchema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
